import { Button, FilterChip, Segmented } from '@indipia/ui-core'
import { SCHEDULE_VIEW_OPTIONS } from '../../views/scheduleUtils'
import {
  LIST_FILTER_OPTIONS, LIST_SORT_LABEL,
  type ListFilter, type ListFilterCounts, type ListSort,
} from '../../types/scheduleList.types'

// 필터 줄(D-03) — 필터 칩 6개(건수) → 정렬 버튼(현재 상태 표시·누르면 반대로) → 우측 보기 전환. 신호등 켜기 토글은 두지 않는다(확정결정 10).

export interface ScheduleListFilterBarProps {
  filter: ListFilter
  counts: ListFilterCounts
  sort: ListSort
  onFilterChange: (next: ListFilter) => void
  onToggleSort: () => void
  /** 보기 전환 세그먼트 선택 — 값은 SCHEDULE_VIEW_OPTIONS 의 value(gantt · cal-b2 · work-type). 현재 보기(work-type)를 다시 누른 경우는 호출하지 않는다 */
  onChangeView: (view: string) => void
}

/** 이 화면의 보기 값 */
const CURRENT_VIEW = 'work-type'

export function ScheduleListFilterBar({ filter, counts, sort, onFilterChange, onToggleSort, onChangeView }: ScheduleListFilterBarProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 'var(--spacing-03)', padding: 'var(--spacing-03) var(--spacing-05)', background: 'var(--shell-bg)', borderBottom: 'var(--border-width-hairline) solid var(--shell-border)' }}>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 'var(--spacing-02)' }}>
        {LIST_FILTER_OPTIONS.map(o => (
          <FilterChip
            key={o.value || 'all'}
            size="lg"
            active={filter === o.value}
            count={counts[o.value]}
            onClick={() => onFilterChange(o.value)}
          >
            {o.label}
          </FilterChip>
        ))}
      </div>
      <Button variant="secondary" size="sm" className="whitespace-nowrap" title="눌러서 정렬 바꾸기" onClick={onToggleSort}>
        {LIST_SORT_LABEL[sort]}
      </Button>
      <div style={{ flex: 1 }} />
      <span style={{ fontSize: 'var(--type-caption-size)', fontWeight: 600, color: 'var(--shell-on-surface-2)', whiteSpace: 'nowrap' }}>보기</span>
      <Segmented
        className="!shrink-0"
        options={SCHEDULE_VIEW_OPTIONS}
        value={CURRENT_VIEW}
        onChange={v => { if (v !== CURRENT_VIEW) onChangeView(v) }}
      />
    </div>
  )
}
